/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ErrorResponse, ProcessAuthorizationCodeParams, UrlResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiTravelPerkController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-travel-perk-controller
   * @name ProcessAuthorizationCode
   * @summary Gets OAuth2 code and tries to establish an integration
   * @request GET:/api/v1/document-fetcher/travelperk/oauth2code
   */
  processAuthorizationCode = (query: ProcessAuthorizationCodeParams, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse | void>({
      path: `/v1/document-fetcher/travelperk/oauth2code`,
      method: 'GET',
      query: query,
      ...params,
    })

  static processAuthorizationCodePath = '/v1/document-fetcher/travelperk/oauth2code'
  static processAuthorizationCodeMethod = 'GET'
  /**
   * No description
   *
   * @tags api-travel-perk-controller
   * @name GetAuthorizationCodeRequestUrl
   * @request GET:/api/v1/document-fetcher/travelperk/authorizationCodeRequestUrl
   */
  getAuthorizationCodeRequestUrl = (params: RequestParams = {}) =>
    this.http.request<UrlResponse, any>({
      path: `/v1/document-fetcher/travelperk/authorizationCodeRequestUrl`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAuthorizationCodeRequestUrlPath =
    '/v1/document-fetcher/travelperk/authorizationCodeRequestUrl'
  static getAuthorizationCodeRequestUrlMethod = 'GET'
}
